import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import type { DashboardStats } from '../../types';
import { apiService } from '../../services/api';
import { StarRatingDisplay } from '../../components/shared/StarRatingDisplay';

export const DashboardPage: React.FC = () => {
  const [data, setData] = useState<DashboardStats | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiService
      .getDashboardStats()
      .then(setData)
      .catch(() => setError('データの取得に失敗しました'));
  }, []);

  if (error) {
    return <div className="rounded-lg bg-red-50 p-4 text-red-700">{error}</div>;
  }

  if (!data) {
    return <div className="text-slate-500">読み込み中...</div>;
  }

  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold text-slate-900">ダッシュボード</h1>

      {/* Statistics cards */}
      <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="rounded-lg border border-slate-200 bg-white p-6">
          <div className="text-sm text-slate-500">総チャットログ数</div>
          <div className="mt-1 text-3xl font-bold text-slate-900">{data.totalChatLogs}</div>
        </div>
        <div className="rounded-lg border border-slate-200 bg-white p-6">
          <div className="text-sm text-slate-500">本日のチャットログ</div>
          <div className="mt-1 text-3xl font-bold text-slate-900">{data.todayChatLogs}</div>
        </div>
      </div>

      {/* Recent chat logs */}
      <h2 className="mb-4 text-xl font-bold text-slate-900">最近のチャットログ</h2>
      {data.recentChatLogs.length === 0 ? (
        <div className="text-slate-500">チャットログはありません</div>
      ) : (
        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium text-slate-500">
                  タイムスタンプ
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-slate-500">
                  セッションID
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium text-slate-500">カテゴリ</th>
                <th className="px-6 py-3 text-left text-sm font-medium text-slate-500">評価</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200">
              {data.recentChatLogs.map((log) => (
                <tr key={log.requestId} className="hover:bg-slate-50">
                  <td className="px-6 py-4 text-sm text-slate-600">
                    {format(new Date(log.timestamp), 'yyyy/MM/dd HH:mm:ss')}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600">{log.sessionId}</td>
                  <td className="px-6 py-4 text-sm text-slate-600">{log.category}</td>
                  <td className="px-6 py-4 text-sm">
                    <StarRatingDisplay rating={log.rating} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
